<template>
  <div id="leftNav" class="background-purple">
    <template v-for="(all, index) in nav">
			<ul :key="index" v-if="all.active">
				<li v-for="(list, index_) in all.item" :key="index_" >
					<a href="javascript: ;" @click="isOpen(index, list)">
            <!-- <i class="el-icon-tickets"></i>&nbsp; -->
            {{ list.title }}&nbsp;<i class="el-icon-arrow-down"></i></a>
					<ul v-if="list.active">
						<li v-for="(item, _index) in list.item" @click="checkActive(index, index_, item)" :key="_index">
							<router-link :to="item.url" :class="{'active': item.active}">{{ item.title }}</router-link>
						</li>
					</ul>
				</li>
			</ul>
		</template>
  </div>
</template>

<script>
export default {
  name: 'leftNav',//左侧导航
  data () {
    return {
      nav: this.$root.Permission
    }
  },
  methods: {
	checkActive (index, index_, item) { //点击三级菜单，跳转路由
			console.log('阿范德萨发生的。。。',item);
			this.$root.Permission.forEach(el => {
				el.item.forEach(el1 => {
					el1.item.forEach(el2 => {
						el2.active = false
					})
				})
			})
			item.active = !item.active
			item.isShow = true
			this.addOpenNav(index, index_, item)
		},
    isOpen (index, item) { //点击二级菜单
			var bl = item.active
			this.$root.Permission[index].item.forEach(el => {
				el.active = false
			})
			if (!bl) {
				item.active = !item.active
			}
		},
    addOpenNav (index, index_, item) {
			var isAdd = true
			this.$root.openNav.forEach(el => {
				if (el.title == item.title) {//判断是否是已打开路由
					isAdd = false
					return
				}
			})
			if (isAdd) { //如果不是已打开路由，则添加进已打开路由列表
				this.$root.openNav.push(item)
			}
		},
  	},
  mounted () {
    this.$root.Permission.forEach((el, i) => {
			el.item.forEach((el1, j) => {
				el1.item.forEach((el2) => {
					if (this.$route.path.indexOf(el2.url) !== -1) {//判断当前路由
						this.checkActive(i, j, el2)
						return
					}
				})
			})
		})
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#leftNav{width: 180px;height: calc(100vh - 50px);}
#leftNav .character{width: 180px;height: 84px;padding: 12px 10px 12px 20px;background: #ECF0F5;}
#leftNav .character .img{width: 60px;height: 60px;border-radius: 30px;padding: 4px;}
#leftNav .character .img>img{width: 52px;height: 52px;border-radius: 26px;}
#leftNav .character .cont{line-height: 30px;padding: 0 0 0 10px;}
#leftNav .character .cencel{right: 10px;top: -10px;}
#leftNav>ul{width: 180px;height: calc(100% - 84px);box-shadow: 5px 0px 5px -5px #e3e3e3;}
#leftNav>ul>li{line-height: 42px;}
#leftNav>ul>li>a{color: #fff;display: block;padding-left: 30px;height: 42px;}
#leftNav>ul>li>ul{width: 180px;}
#leftNav>ul>li>ul>li{height: 42px;line-height: 42px; position: relative;}
#leftNav>ul>li>ul>li>a{color: #fff;display: block;padding-left: 50px;height: 42px;}
#leftNav>ul>li>ul>li>a.active{background: #0F1012;color: #fff;}
#leftNav>ul>li>ul>li>a.active::before{content: '';width: 3px; height: 40px; background: #2480ED; left: 0; top: 0; position: absolute;}
#leftNav>ul>li>ul>li>a:hover{background: #0F1012;color: #fff;}
</style>



// WEBPACK FOOTER //
// src/components/nav.vue